export enum HttpRequestHeadersEnum {
  ContentType = 'Content-Type',
  ApplicationJson = 'application/json'
}
export type HttpRequestHeadersEnumType = keyof typeof HttpRequestHeadersEnum;
